import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import { BiMailSend } from 'react-icons/bi';

const defaultToolbarStyles = {
  iconButton: {},
};

class CustomToolbar extends React.Component {
  handleClick = (e) => {
    console.log(this.props.handleOpen('enviar', e));
  };

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        {/* <Tooltip title={'Enviar para para Parceiros'}>
          <IconButton className={classes.iconButton} onClick={this.handleClick}>
            <IoSend className={classes.deleteIcon} />
          </IconButton>
        </Tooltip> */}
        <Tooltip title={'Enviar para Parceiros'}>
          <span>
            <IconButton
              className={classes.iconButton}
              onClick={this.handleClick}
              disabled={this.props.peqAlmocos.length <= 0 ? true : false}
            >
              <BiMailSend className={classes.deleteIconDisabled} />
            </IconButton>
          </span>
        </Tooltip>
      </React.Fragment>
    );
  }
}

export default withStyles(defaultToolbarStyles, { name: 'CustomToolbar' })(CustomToolbar);
